'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _DetailsToInvoiceForm = require('./DetailsToInvoiceForm.scss');var _DetailsToInvoiceForm2 = _interopRequireDefault(_DetailsToInvoiceForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var DetailsToInvoiceInputField = function DetailsToInvoiceInputField(props) {
  var isInvalid = props.meta.error && !props.meta.active && props.meta.touched;
  return (
    _react2.default.createElement('div', { className: _DetailsToInvoiceForm2.default.inputWrapper },
      _react2.default.createElement('input', _extends({
        type: 'text',
        placeholder: props.placeholder,
        className: (0, _classnames2.default)(
        'form-control',
        {
          not_valid: isInvalid,
          touched: props.meta.touched }) },


      props.input, {
        id: props.input.name })),

      _react2.default.createElement('span', { className: 'icon icon-' + props.iconName }),
      isInvalid && _react2.default.createElement('span', { className: _DetailsToInvoiceForm2.default.errorMsg }, props.errorMsg)));


};

DetailsToInvoiceInputField.propTypes = {
  iconName: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  errorMsg: _propTypes2.default.string,
  meta: _propTypes2.default.object,
  input: _propTypes2.default.object };exports.default =


DetailsToInvoiceInputField;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DetailsToInvoiceForm/DetailsToInvoiceInputField.js
// module id = 1237
// module chunks = 0